import React from "react";
import PropTypes from "prop-types";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components/index";
import {Button, ButtonGroup, Modal, ModalBody, ModalFooter} from 'reactstrap';
import moment from "moment";
import API from "@beardeddevops/react.api";
import Card from '@material-ui/core/Card';
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import ExpandMore from '@material-ui/icons/ExpandMore';
import ShowChart from '@material-ui/icons/ShowChart';
import Map from "@material-ui/icons/Map";
import EngineerHDCard from "../Parts/EngineerHDCard";
import {Tooltip} from "@material-ui/core";
import UserRoles from "../../constants/UserRoles";
import Parts from "components/Parts";

class ScheduleFieldEngineer extends Framework.Components.Object {
	static propTypes = {
		...Framework.Components.Collection.propTypes,
		provideLocation: PropTypes.func,
	};

	constructor(props) {
		super(props, Types.Tickets._name);
		this.state.days = [];
		this.state.feAvailability = null;
		this.state.filterSlots = [];
		this.state.filterDate = props.defaultDate ? props.defaultDate : moment().format();
		this.state.shouldShowWarning = false;
		this.state.show_hd_modal = false;
	}

	async componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot)
		if (!this.props.isSaving && ((this.props.location !== prevProps.location) || (this.props.isRemoteWork !== prevProps.isRemoteWork) || (this.props.isRevisit !== prevProps.isRevisit) || (this.props.selectedAddress !== prevProps.selectedAddress))) {
			await this.setState({startAppt: null, endAppt: null, selectedAppt: null});
			this.setState({shouldShowWarning: false, newFilterDate: null})
			await this.getAvailabilityData(true);
		}
		if (!this.dataInterval) {
			this.dataInterval = setInterval(async () => {
				if (!this.props.isSaving && !this.props.isRevisit && (this.props.location || this.props.isRemoteWork || this.props.isRevisit)) {
					await this.getAvailabilityData(true, true);
				}
			}, 120000)
		}
	}

	async componentDidMount() {
		super.componentDidMount();
		if (this.props.shouldLoadInitial) {
			await this.getAvailabilityData(true)
		}
	}

	componentWillUnmount() {
		if (this.dataInterval) {
			clearInterval(this.dataInterval);
			this.dataInterval = null;
		}
	}

	getAvailabilityData = async (filterBool = true, skipRefresh = false) => {
		if (!skipRefresh) {
			this.setState({new_mileages: null})
		}
		if (!this.props.isRemoteWork && !this.props.location && !this.props.isRevisit) return;
		let model = new API.BuildClass(Types.Users._name, API.RequestType.READ_ALL);
		this.read = 'GET_SCHEDULE_FIELD_ENGINEER';
		model.limit = 5000;
		let week = moment(this.state.filterDate).isoWeek();
		if (moment(this.state.filterDate).isoWeekday() === 7) {
			week++;
		}
		model.filter = {
			'filterDate': this.state.filterDate,
			'filterRegions': (this.props.isRemoteWork || this.props.isRevisit) ? null : this.props.location ?? null,
			'filterSlots': this.state.filterSlots,
			'filterBool': filterBool,
			'revisit': this.props.isRevisit,
			'timeOffWeek': moment(this.state.filterDate).year().toString() + week.toString(),
			'allFes': this.props.allFes ?? false,
			'fromDispatch': this.props.fromDispatch === true,
			...(this.props.isRevisit ? {bookableOnly: true} : {}),
		}

		try {
			this.feAvailability = await model.submit(null, this.read);
			let formattedUrls = [];
			this.feAvailability.mapsUrls?.forEach((item) => {
				formattedUrls[Object.keys(item)[0]] = item[Object.keys(item)];
			})

			if (this.state.selectedAppt) {
				this.feAvailability.items.map((fe) => {
					let selectedFe = this.state.selectedAppt.split('|')[0]
					let selectedSlot = this.state.selectedAppt.split('|')[1]

					if (this.feAvailability.items.filter(item => item.pkey == selectedFe).length === 0) {
						this.setState({selectedAppt: null, startAppt: null, endAppt: null})
						return;
					}

					if (fe.pkey != selectedFe) return;

					let availability = fe.availability.replaceAll(' ', '').split(',');

					if (!availability.includes(selectedSlot)) {
						this.setState({selectedAppt: null, startAppt: null, endAppt: null})
					}
				})
			}

			await this.setState({
				feAvailability: this.feAvailability.items ?? null,
				newFilterDate: this.state.newFilterDate === null ? this.feAvailability.newFilterDate ? this.feAvailability.newFilterDate : null : this.state.newFilterDate,
				filterDate: this.feAvailability.newFilterDate ? this.feAvailability.newFilterDate : this.state.filterDate,
				mapsUrls: formattedUrls,
				shouldShowWarning: this.state.newFilterDate === null ? !!this.feAvailability.newFilterDate : true,
				mileages: this.feAvailability.mileage
			})

			if (typeof (this.props.getMileage) === 'function') {
				this.props.getMileage(this.feAvailability.mileage)
			}

			this.props.updateFilterDate(this.feAvailability.newFilterDate ?? this.state.filterDate)
			if (typeof this.props.updateFePkeys === 'function') {
				let pkeys = [];
				this.state.feAvailability.map((item) => {
					pkeys.push({value: item.pkey, label: item.name_first + " " + item.name_last})
				})
				this.props.updateFePkeys(pkeys);
			}
		} catch (e) {
			console.log(e)
		}

		if (this.props.optionalCallback) {
			let data = '';
			this.state.feAvailability.forEach((item) => {
				data += item.pkey.toString() + '|' + item.availability + '||'
			})

			this.props.optionalCallback(data);
		}
	}


	toggleClose = (modal) => {
		this.setState({
			[modal]: !this.state[modal],
			show_hd_modal: false
		});
	}

	handleTimeSlotSelect = async (event) => {
		if (this.state.filterSlots.includes(event.currentTarget.id)) {
			let _filterSlots = this.state.filterSlots;
			_filterSlots.splice(this.state.filterSlots.indexOf(event.currentTarget.id), 1)
			await this.setState({filterSlots: _filterSlots})
		} else {
			await this.setState({filterSlots: [...this.state.filterSlots, event.currentTarget.id]})
		}
		await this.setState({startAppt: null, endAppt: null, selectedAppt: null});
		await this.getAvailabilityData(false);
	}

	handleDaySelect = async (event) => {
		let date = null;
		let minDate = this.state.newFilterDate ? moment(this.state.newFilterDate).format('dddd MMM D') : moment().format('dddd MMM D');
		let currentDate = this.state.filterDate;
		switch (event.currentTarget.id) {
			case 'sub':
				if (moment(currentDate).format('dddd MMM D') === minDate) {
					if (minDate !== moment().format('dddd MMM D')) {
						this.setState({shouldShowWarning: true})
					}
					return;
				}
				date = moment(currentDate).subtract(1, 'day').format()
				this.setState({shouldShowWarning: false})
				break;
			case 'add':
				date = moment(currentDate).add(1, 'day').format()
				this.setState({shouldShowWarning: false})
				break;
			case 'today':
				if (moment().format('dddd MMM D') !== minDate) {
					date = moment(this.state.newFilterDate).format();
					this.setState({shouldShowWarning: true})
				} else {
					date = moment().format();
				}
				break;
		}
		await this.setState({filterDate: date, startAppt: null, endAppt: null, selectedAppt: null});
		await this.getAvailabilityData(false);
		this.props.updateFilterDate(date)
	}

	getHelpdesks = async (engineer) => {
		let model = new API.BuildClass(Types.Users_Help_Desk._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		model.filter = {
			'day': moment().format(),
			'users': [engineer],
			'shouldTrack': false
		}
		this.data = await model.submit(null, this.read);
		this.data = this.data.items;
		this.setState({
			field_engineer: this.data?.[0] ?? null,
			show_hd_modal: true
		});
	}

	styleTotalDriveTime = addedDriveTime => {
		let textColor;

		if (!addedDriveTime) return;

		if (addedDriveTime < 15) {
			textColor = "green";
		} else if (addedDriveTime >= 15 && addedDriveTime < 30) {
			textColor = "#D5B60A";
		} else {
			textColor = "red";
		}

		return textColor;
	}

	addingAdditionalDriveTime = async (fe, slot) => {
		let model = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		model.filter = {
			'filterDate': moment(this.state.filterDate).format('YYYY-MM-DD'),
			'filterUsers': [fe],
			'filterSlot': slot,
			'filterAddress': this.props.selectedAddress
		}
		const data = await model.submit(null, 'GET_FE_MILEAGE');
		this.setState({new_mileages: data.items});
	}

	handleTimeSlotClick = async (fe, slot, startAppt, endAppt, selectedAppt) => {
		if (this.props.noSubmit) return;
		if (this.props.isRemoteWork !== true) {
			await this.addingAdditionalDriveTime(fe, slot);
		}
		this.setState({
			startAppt: startAppt,
			endAppt: endAppt,
			noTime: false,
			selectedAppt: (fe + selectedAppt),
			selectedFE: fe,
		})
		if (this.props.forceOverrideWarning) {
			this.props.forceOverrideWarning();
		}
	}

	render() {
		let {properties} = this.model;
		let object = this.state;

		if (!object.loaded) {
			return (
				<Framework.Elements.LoadingSpinner isLoading={true}/>
			)
		}

		const available_engineers = this.state.feAvailability === null ? <h4>There are no engineers in the selected region.</h4> :
			<Card>
				<div className={'form-group'}>
					<div className={'row'}>
						<div className={'col-12'}>
							<h4 className="section-title">
								<div className={'row'}>
									<div className={'col-6'}>
										Available Field Engineers
									</div>
									<div className={'col-4 flex-end text-right'}>
										Openings
									</div>
									<div className={'col-2 flex-end text-right'}>
										<button onClick={() => this.setState({collapsed: !this.state.collapsed})}>
											{this.state.collapsed ? <RightArrowIcon/> : <ExpandMore/>}
										</button>
									</div>
								</div>
								<div className={'row'}>
									<div className={'col-6'}>
										Total Drive Time
									</div>
								</div>
							</h4>
						</div>
					</div>
					{this.state.feAvailability.map((fe, index) => {
						let availability = fe.availability.replaceAll(' ', '').split(',');
						let remotes = [];
						if (fe && fe.appointments) {
							remotes = fe.appointments.filter((item) => item.remoteSlot).map((item) => item.remoteSlot)
						}
						return (
							this.state.collapsed ? null : <div key={fe.pkey + " Card"}>
								<div className={'row'} style={{alignItems: 'center', marginTop: '2px', marginBottom: '2x'}}>
									<div className={this.props.noSubmit ? 'col-4' : 'col-3'}
									     style={{justifyContent: 'center', alignSelf: 'center', display: 'flex', flexDirection: 'column'}}>
										<p style={{
											fontSize: '18px',
											fontWeight: 'bolder',
											color: !this.props.isRevisit && !this.props.isRemoteWork ? this.props.userColors ? this.props.userColors[fe.pkey] ? this.props.userColors[fe.pkey] : 'black' : 'black' : 'black',
											marginBottom: '5px',
											paddingLeft: "5px"
										}}>{fe.name_first + " " + fe.name_last}</p>
										{(moment(this.state.filterDate).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) &&
											<p style={{cursor: "pointer", paddingLeft: '12px', fontWeight: "bold", marginBottom: '2px'}}
											   title="Show full day"
											   onClick={async () => {
												   //pop hd modal here
												   await this.getHelpdesks(fe.pkey)
											   }}>{fe.last_status}</p>}
										{this.state.mileages && (this.state.mileages[fe.pkey] || (this.state.new_mileages && this.state.new_mileages[fe.pkey])) &&
											<p style={{
												fontStyle: "italic",
												fontWeight: "bold",
												paddingLeft: '12px',
												color: this.state.new_mileages && this.state.new_mileages[fe.pkey]?.drive_time !== this.state.mileages[fe.pkey]?.drive_time ? this.styleTotalDriveTime(this.state.new_mileages[fe.pkey]?.drive_time - (this.state.mileages[fe.pkey]?.drive_time ?? 0)) : 'black'
											}}
											   title={this.state.new_mileages && this.state.new_mileages[fe.pkey]?.drive_time !== this.state.mileages[fe.pkey]?.drive_time ? `Selected appointment added ${Math.round((this.state.new_mileages[fe.pkey]?.drive_time - (this.state.mileages[fe.pkey]?.drive_time ?? 0)) * 100) / 100} minutes to the estimated total drive time.` : "Estimated total drive time for selected day"}
											   id={"Total Drive Time"}
											>{(this.state.new_mileages && this.state.new_mileages[fe.pkey]?.drive_time !== this.state.mileages[fe.pkey]?.drive_time && this.state.selectedFE === fe.pkey) ? this.state.new_mileages[fe.pkey]?.drive_time : this.state.mileages[fe.pkey]?.drive_time} min
												drive</p>}
									</div>
									{!this.props.noSubmit &&
										<div className={'col-1'}>
											{this.state.mapsUrls[fe.pkey] ? (
												<a href={this.state.mapsUrls[fe.pkey]} target={'_blank'}>
													<Map/>
												</a>
											) : null}
										</div>}
									<div className={'col-8'}>
										{this.props.isRevisit ? <ButtonGroup size={"md"}>
											<Button
												id={"2PM-5PM"}
												onClick={async () => await this.handleTimeSlotClick(fe.pkey, "10:30:00-13:30:00", "10:30:00", "13:30:00", "|1030AM-130PM")}
												outline={this.state.selectedAppt !== (fe.pkey + "|1030AM-130PM")}
												active={this.state.selectedAppt === (fe.pkey + "|1030AM-130PM")}
												color={this.state.noTime ? 'danger' : "primary"}
											>
												10:30AM - 1:30PM
											</Button>

											<Button
												id={"4PM-7PM"}
												onClick={async () => await this.handleTimeSlotClick(fe.pkey, "16:00:00-19:00:00", "16:00:00", "19:00:00", "|4PM-7PM")}
												outline={this.state.selectedAppt !== (fe.pkey + "|4PM-7PM")}
												active={this.state.selectedAppt === (fe.pkey + "|4PM-7PM")}
												color={"secondary"}
											>
												4PM - 7PM
											</Button>
										</ButtonGroup> : <ButtonGroup size={"md"}>
											{availability.includes("8AM-10AM") && (fe.holes ? parseInt(fe.holes) > 0 : remotes.includes("8AM-10AM")) && (
												<Tooltip key={Math.random()}
												         title={remotes.includes("8AM-10AM") ? "A Remote Appointment is scheduled in this time (move to another person in any metro)." : ''}
												         arrow>
													<Button
														id={"8AM-10AM"}
														onClick={async () => await this.handleTimeSlotClick(fe.pkey, "08:00:00-10:00:00", "08:00:00", "10:00:00", "|8AM-10AM")}
														outline={this.state.selectedAppt !== (fe.pkey + "|8AM-10AM")}
														active={this.state.selectedAppt === (fe.pkey + "|8AM-10AM")}
														color={remotes.includes("8AM-10AM") ? "warning" : this.state.noTime ? 'danger' : "primary"}
														onMouseOver={async () => {
															this.hoverTimeout = setTimeout(async () => {
																console.log('API called after 0.5s hover');

															}, 750);
														}}
														onMouseLeave={() => {
															clearTimeout(this.hoverTimeout);
														}}
														title={``}
													>
														8AM - 10AM
													</Button>
												</Tooltip>
											)}

											{availability.includes("9AM-12PM") && (fe.holes ? parseInt(fe.holes) > 0 : remotes.includes("9AM-12PM")) &&
												<Tooltip key={Math.random()}
												         title={remotes.includes("9AM-12PM") ? "A Remote Appointment is scheduled in this time (move to another person in any metro)." : ''}
												         arrow>
													<Button
														id={"9AM-12PM"}
														onClick={async () => await this.handleTimeSlotClick(fe.pkey, "09:00:00-12:00:00", "09:00:00", "12:00:00", "|9AM-12PM")}
														outline={this.state.selectedAppt !== (fe.pkey + "|9AM-12PM")}
														active={this.state.selectedAppt === (fe.pkey + "|9AM-12PM")}
														color={remotes.includes("9AM-12PM") ? "warning" : this.state.noTime ? 'danger' : "primary"}
														onMouseOver={async () => {
															this.hoverTimeout = setTimeout(async () => {
																console.log('API called after 0.5s hover');

															}, 750);
														}}
														onMouseLeave={() => {
															clearTimeout(this.hoverTimeout);
														}}
														title={``}
													>
														9AM - 12PM
													</Button>
												</Tooltip>}

											{availability.includes("12PM-3PM") && (fe.holes ? parseInt(fe.holes) > 0 : remotes.includes("12PM-3PM")) &&
												<Tooltip key={Math.random()}
												         title={remotes.includes("12PM-3PM") ? "A Remote Appointment is scheduled in this time (move to another person in any metro)." : ''}
												         arrow>
													<Button
														id={"12PM-3PM"}
														onClick={async () => await this.handleTimeSlotClick(fe.pkey, "12:00:00-15:00:00", "12:00:00", "15:00:00", "|12PM-3PM")}
														outline={this.state.selectedAppt !== (fe.pkey + "|12PM-3PM")}
														active={this.state.selectedAppt === (fe.pkey + "|12PM-3PM")}
														color={remotes.includes("12PM-3PM") ? "warning" : this.state.noTime ? 'danger' : "primary"}
														onMouseOver={async () => {
															this.hoverTimeout = setTimeout(async () => {
																console.log('API called after 0.5s hover');

															}, 750);
														}}
														onMouseLeave={() => {
															clearTimeout(this.hoverTimeout);
														}}
														title={``}
													>
														12PM - 3PM
													</Button>
												</Tooltip>}

											{availability.includes("2PM-5PM") && (fe.holes ? parseInt(fe.holes) > 0 : remotes.includes("2PM-5PM")) &&
												<Tooltip key={Math.random()}
												         title={remotes.includes("2PM-5PM") ? "A Remote Appointment is scheduled in this time (move to another person in any metro)." : ''}
												         arrow>
													<Button
														id={"2PM-5PM"}
														onClick={async () => await this.handleTimeSlotClick(fe.pkey, "14:00:00-17:00:00", "14:00:00", "17:00:00", "|2PM-5PM")}
														outline={this.state.selectedAppt !== (fe.pkey + "|2PM-5PM")}
														active={this.state.selectedAppt === (fe.pkey + "|2PM-5PM")}
														color={remotes.includes("2PM-5PM") ? "warning" : this.state.noTime ? 'danger' : "primary"}
														onMouseOver={async () => {
															this.hoverTimeout = setTimeout(async () => {
																console.log('API called after 0.5s hover');

															}, 750);
														}}
														onMouseLeave={() => {
															clearTimeout(this.hoverTimeout);
														}}
														title={``}
													>
														2PM - 5PM
													</Button>
												</Tooltip>}

											{availability.includes("4PM-7PM") && (fe.holes ? parseInt(fe.holes) > 0 : remotes.includes("4PM-7PM")) &&
												<Tooltip key={Math.random()}
												         title={remotes.includes("4PM-7PM") ? "A Remote Appointment is scheduled in this time (move to another person in any metro)." : ''}
												         arrow>
													<Button
														id={"4PM-7PM"}
														onClick={async () => await this.handleTimeSlotClick(fe.pkey, "16:00:00-19:00:00", "16:00:00", "19:00:00", "|4PM-7PM")}
														outline={this.state.selectedAppt !== (fe.pkey + "|4PM-7PM")}
														active={this.state.selectedAppt === (fe.pkey + "|4PM-7PM")}
														color={remotes.includes("4PM-7PM") ? "warning" : "secondary"}
														onMouseOver={async () => {
															this.hoverTimeout = setTimeout(async () => {
																console.log('API called after 0.5s hover');

															}, 750);
														}}
														onMouseLeave={() => {
															clearTimeout(this.hoverTimeout);
														}}
														title={``}
													>
														4PM - 7PM
													</Button>
												</Tooltip>}
										</ButtonGroup>}
									</div>
								</div>
							</div>
						)
					})}
				</div>
			</Card>

		return (
			<div>
				<div>
					<div className={'section-title'}>
						<h4 className="section-title">Schedule Field Engineer</h4>
						<div className={'flex-end text-right align-self-center pr-1'} style={{gap: '5px', display: 'flex', alignItems: 'center'}}>
							<Parts.FDCountDisplay type={'pending'} count={this.props.pending_count} triggerModal={this.props.triggerFDGraphModal}/>
						</div>
					</div>
					<div className={"row"}>
						<div className={"col-4"} style={{display: "flex", fontSize: 20, justifyContent: "center", marginTop: '-25px'}}>
							<div className={"row rbc-toolbar"}>
								<div className={"rbc-toolbar-label"} style={{marginTop: '10px'}}>
									<label onClick={this.showDatePicker}>
										{moment(this.state.filterDate).format('dddd MMM D')}
									</label>
								</div>
								<div className={"rbc-btn-group"} style={{marginTop: '-20px'}}>
									<Button id={'sub'} onClick={this.handleDaySelect}><LeftArrowIcon/></Button>
									<Button id={'today'} onClick={this.handleDaySelect}>Today</Button>
									<Button id={'add'} onClick={this.handleDaySelect}><RightArrowIcon/></Button>
								</div>
							</div>
						</div>
						<div className={"col-8"}>
							<div className="form-group">
								<ButtonGroup size={"md"}>
									<Button
										id={"8AM-10AM"}
										onClick={this.handleTimeSlotSelect}
										outline={!this.state.filterSlots.includes("8AM-10AM")}
										active={this.state.filterSlots.includes("8AM-10AM")}
									>
										8AM - 10AM
									</Button>

									<Button
										id={"9AM-12PM"}
										onClick={this.handleTimeSlotSelect}
										outline={!this.state.filterSlots.includes("9AM-12PM")}
										active={this.state.filterSlots.includes("9AM-12PM")}
									>
										9AM - 12PM
									</Button>

									<Button
										id={"12PM-3PM"}
										onClick={this.handleTimeSlotSelect}
										outline={!this.state.filterSlots.includes("12PM-3PM")}
										active={this.state.filterSlots.includes("12PM-3PM")}
									>
										12PM - 3PM
									</Button>

									<Button
										id={"2PM-5PM"}
										onClick={this.handleTimeSlotSelect}
										outline={!this.state.filterSlots.includes("2PM-5PM")}
										active={this.state.filterSlots.includes("2PM-5PM")}
									>
										2PM - 5PM
									</Button>

									<Button
										id={"4PM-7PM"}
										onClick={this.handleTimeSlotSelect}
										outline={!this.state.filterSlots.includes("4PM-7PM")}
										active={this.state.filterSlots.includes("4PM-7PM")}
										color={"secondary"}
									>
										4PM - 7PM
									</Button>
								</ButtonGroup>
							</div>
						</div>
					</div>
					{this.state.shouldShowWarning &&
						<div className={'row'}>
							<div className={'col-12'}>
								<b>The earliest available appointment for this metro is {moment(this.state.newFilterDate).format('dddd MMM D')}.</b>
							</div>
						</div>}
					<div className={'row'}>
						<div className={'col-12'}>
							{available_engineers}
						</div>
					</div>
				</div>

				<Modal
					isOpen={this.state.show_hd_modal}
					toggle={this.toggleClose}
					size={"xl"}
					backdrop={true}
					style={{opacity: 1, maxWidth: window.innerWidth * .9}}
				>
					<ModalBody>
						<div className={'form-group'}>
							{this.state.field_engineer ?
								<EngineerHDCard history={this.props.history} currentDay={moment(this.state.selectedDay).format("YYYY-MM-DD")}
								                engineer={this.state.field_engineer} refreshData={async () => {
									await this.getHelpdesks(this.state.field_engineer?.pkey)
								}}/>
								: <p>No helpdesk data available for this field engineer.</p>}
						</div>
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={this.toggleClose}>Close</Button>
					</ModalFooter>
				</Modal>

				<Framework.Elements.LoadingSpinner isLoading={object.loading}/>
			</div>
		)
	}
}

export default Framework.Components.withRootState(ScheduleFieldEngineer);
